import { useCurrentUserStore } from 'stores/currentUser';
import { useRedirectPathStore } from 'stores/redirectPathAfterLogin';
import { auth } from 'boot/firebase';
import { route } from 'quasar/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';

import routes from './routes';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });
  Router.beforeEach((to, from, next) => {
    const store = useCurrentUserStore();
    const redirectPathStore = useRedirectPathStore();
    // 認証が必須のページ
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      auth.onAuthStateChanged(async (user) => {
        // ログインしていない
        if (!user) {
          // 本来はaccountsサービスがCookiesをセットします。
          //Cookies.set('id_token', JSON.stringify({ hoge: 'hoge' }), {
          //  expires: '1h',
          //});
          const redirectPath = to.fullPath;
          redirectPathStore.setPath(redirectPath);
          //SessionStorage.set('redirect_path', redirectPath);
          next({ name: 'login' });
        }
        // ログインしている
        else {
          // currentUserがない
          if (!store.isLogined) {
            await store.setCurrentUser(user);
            next();
          }
          // currentUserがある
          else {
            next();
          }
        }
      });
    }
    // 認証が不要のページ
    else {
      next();
    }
  });

  return Router;
});
